import { all, call, put, takeEvery } from "redux-saga/effects";
import * as actions from "../slices/tenantSlice";

import tenantApis from "src/api/tenant";

import { common } from "src/types/index";
import { constants } from "src/constants/common";

// create tenant saga
const CreateTenantSaga = function* CreateTenantSaga({
  payload,
}: ReturnType<typeof actions.createTenantRequest> & { payload: any }) {
  try {
    const response: common.ResponseGenerator = yield call(
      tenantApis.createTenant,
      payload
    );

    yield put(actions.createTenantSuccess(response));
  } catch (error) {
    yield put(
      actions.createTenantError(
        error instanceof Error
          ? error?.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
  }
};

// edit tenant saga
const EditTenantSaga = function* EditTenantSaga({
  payload,
}: ReturnType<typeof actions.editTenantRequest> & { payload: any }) {
  try {
    const response: common.ResponseGenerator = yield call(
      tenantApis.editTenant,
      payload
    );

    yield put(actions.editTenantSuccess(response));
  } catch (error) {
    yield put(
      actions.editTenantError(
        error instanceof Error
          ? error?.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
  }
};

// get tenants list saga
const GetTenantsListSaga = function* GetTenantsListSaga({
  payload,
}: ReturnType<typeof actions.getTenantsListRequest> & {
  payload: { page: number; limit: number };
}) {
  try {
    const response: common.ResponseGenerator = yield call(
      tenantApis.getTenantList,
      payload
    );

    yield put(actions.getTenantsListSuccess(response));
  } catch (error) {
    yield put(
      actions.getTenantsListError(
        error instanceof Error
          ? error?.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
  }
};

// get tenant details saga
const GetTenantDetailsSaga = function* GetTenantDetailsSaga({
  payload,
}: ReturnType<typeof actions.getTenantDetailsRequest> & { payload: string }) {
  try {
    const response: common.ResponseGenerator = yield call(
      tenantApis.getTenantDetails,
      payload
    );

    yield put(actions.getTenantDetailsSuccess(response));
  } catch (error) {
    yield put(
      actions.getTenantDetailsError(
        error instanceof Error
          ? error?.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
  }
};

// create tenant role saga
const CreateTenantRoleSaga = function* CreateTenantRoleSaga({
  payload,
}: ReturnType<typeof actions.createTenantRoleRequest> & { payload: any }) {
  try {
    const response: common.ResponseGenerator = yield call(
      tenantApis.createTenantRole,
      payload
    );

    yield put(actions.createTenantRoleSuccess(response));
  } catch (error) {
    yield put(
      actions.createTenantRoleError(
        error instanceof Error
          ? error?.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
  }
};

// edit tenant role saga
const EditTenantRoleSaga = function* EditTenantRoleSaga({
  payload,
}: ReturnType<typeof actions.editTenantRoleRequest> & { payload: any }) {
  try {
    const response: common.ResponseGenerator = yield call(
      tenantApis.editTenantRole,
      payload
    );

    yield put(actions.editTenantRoleSuccess(response));
  } catch (error) {
    yield put(
      actions.editTenantRoleError(
        error instanceof Error
          ? error?.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
  }
};

// get tenants list saga
const GetTenantRoleListSaga = function* GetTenantRoleListSaga({
  payload,
}: ReturnType<typeof actions.getTenantRoleListRequest> & {
  payload: any;
}) {
  try {
    const response: common.ResponseGenerator = yield call(
      tenantApis.getTenantRoleList,
      payload
    );

    yield put(actions.getTenantRoleListSuccess(response));
  } catch (error) {
    yield put(
      actions.getTenantRoleListError(
        error instanceof Error
          ? error?.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
  }
};

// get tenants list saga
const DeleteTenantRoleSaga = function* DeleteTenantRoleSaga({
  payload,
}: ReturnType<typeof actions.deleteTenantRoleRequest> & {
  payload: any;
}) {
  try {
    const response: common.ResponseGenerator = yield call(
      tenantApis.deleteTenantRole,
      payload
    );

    yield put(actions.deleteTenantRoleSuccess(response));
  } catch (error) {
    yield put(
      actions.deleteTenantRoleError(
        error instanceof Error
          ? error?.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
  }
};
export default function* tenantSaga() {
  yield all([takeEvery(actions.createTenantRequest, CreateTenantSaga)]);
  yield all([takeEvery(actions.editTenantRequest, EditTenantSaga)]);
  yield all([takeEvery(actions.getTenantsListRequest, GetTenantsListSaga)]);
  yield all([takeEvery(actions.getTenantDetailsRequest, GetTenantDetailsSaga)]);
  yield all([takeEvery(actions.createTenantRoleRequest, CreateTenantRoleSaga)]);
  yield all([takeEvery(actions.editTenantRoleRequest, EditTenantRoleSaga)]);
  yield all([
    takeEvery(actions.getTenantRoleListRequest, GetTenantRoleListSaga),
  ]);
  yield all([takeEvery(actions.deleteTenantRoleRequest, DeleteTenantRoleSaga)]);
}
